import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {IoniconsOutline, NotificationType} from "@pt/pt-models";
import {GenericReportService} from "@pt/api-client";
import {CreateGenericReportRequest} from "it/primatoo/openapi/api/org/schemas/genericreport/CreateGenericReportRequest";
import {PtCoreActions} from "@pt/pt-core";
import {Store} from "@ngrx/store";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'pt-generic-report-form',
  template: `
    <div class="report-container">
      <div class="report-content bg-dark bg-opacity-10">
        <div class="h5 p-3">Nuovo Incidente Informatico</div>
        <div class="mt-3 px-3" style="padding-bottom: 60px" [formGroup]="formGroup">
          <div class="form-group row">
            <pt-input-label class="col-md-4 col-12"
                            [label]="'LABELS.AUTHOR' | translate"
                            [isRequired]="true"
            ></pt-input-label>
            <div class="col">
              <input type='text'
                     autocomplete='off'
                     formControlName='author'
                     class='form-control form-control-sm'>
            </div>
          </div>

          <div class="form-group row">
            <pt-input-label class="col-md-4 col-12"
                            [label]="'LABELS.TITLE' | translate"
                            [isRequired]="true"
            ></pt-input-label>
            <div class="col">
              <input type='text'
                     autocomplete='off'
                     formControlName='title'
                     class='form-control form-control-sm'>
            </div>
          </div>

          <div class="form-group row">
            <pt-input-label class="col-md-4 col-12"
                            [label]="'LABELS.DESCRIPTION' | translate"
                            [isRequired]="true"
            ></pt-input-label>
            <div class="col">
              <textarea rows="5"
                        autocomplete='off'
                        formControlName='description'
                        class='form-control form-control-sm'
              ></textarea>
            </div>
          </div>

          <div class="d-flex justify-content-end">
            <pt-button-with-loader
              class='ms-1'
              [disabled]='formGroup.invalid || formGroup.pristine'
              [loading]='loading'
              [label]="'BUTTON.SAVE' | translate"
              [cssClass]="'btn btn-primary btn-sm'"
              (buttonWithLoaderClick)='onSave()'
              [mainIcon]='IconSave'
            ></pt-button-with-loader>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .report-container {
      width: 100%;
      height: 100vh;
      display: grid;
      background-color: #f8f8f8;
    }

    .report-content {
      margin: 0 30%;
      position: relative;
    }

    .report-footer {
      bottom: 0;
      width: 100%;
      height: 80px;
      display: flex;
      position: absolute;
      flex-direction: column;
      background-color: #324f86;
      justify-content: space-between;
    }

    @media (max-height: 335px) {
      .report-container {
        height: 100%;
      }
    }

    @media (max-width: 768px) {
      .report-content {
        margin: 0 20%;
      }
    }

    @media (max-width: 425px) {
      .report-content {
        margin: 0;
      }
    }

    @media (max-width: 320px) {
      .report-content {
        margin: 0;
      }
    }
  `]
})

export class GenericReportFormComponent {

  public loading = false;
  public IconSave = IoniconsOutline.save;

  public formGroup = new FormGroup({
    title: new FormControl(null, [Validators.required]),
    author: new FormControl(null, [Validators.required]),
    description: new FormControl(null, Validators.required),
  });

  constructor(private genericReportService: GenericReportService,
              private translateService: TranslateService,
              private store: Store
  ) {
  }

  onSave() {
    const form = this.formGroup.getRawValue();
    const request: CreateGenericReportRequest = {
      title: form.title,
      author: form.author,
      description: form.description
    }
    this.genericReportService.create(request).subscribe(() => {
      this.store.dispatch(PtCoreActions.showNotification({
        notification: {
          type: NotificationType.success,
          title: this.translateService.instant('SIDEBAR.GENERIC_REPORT'),
          message: this.translateService.instant('MESSAGE.OPERATION_SUCCESS')
        }
      }));
      this.formGroup.reset();
    });
  }
}

